
export default {
  name: "page",
  props: {
    title: String
  }
};
